import hideGmae from "@/lobby_common/mixins/hideGmae.js";
import GameMaintai from "@/components/game/game-maintai";
import Collection from "@/components/collection/index.vue";
import { gameImg } from "@/lobby_common/utils/img.js";
import { payGameFun } from "@/lobby_common/utils/payGameFun.js";
import { getLocalStorage, setLocalStorage } from "@/lobby_common/utils/auth";
import { replacePoint } from "@/lobby_common/utils/utils.js";
import { goJoinEvent } from "@/lobby_common/utils/utils.js";
export default {
  name: "game-item",
  mixins: [hideGmae],
  components: { Collection, GameMaintai },
  props: {
    item: {
      type: [Object],
      default: () => ({}),
    },
    skeletonLoading: {
      type: Boolean,
      default: false,
    },
    target: {
      type: Number,
      default: 0,
    },
    isHotNew: {  // 是否热门游戏弹窗
      type: Number,
      default: 0,
    },
    // eid: {
    //   type: String,
    //   default: "",
    // },
    // jp_show: {
    //   type: Number,
    //   default: 0,
    // },
  },
  data() {
    return {
      lazyStatus: "loading", // 初始状态为 loading
      loadingtype: true,
      loadingsrc:
        "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
      replacePoint,
      gameImg,
      total: 0,
      currGameId: undefined,
      keyImgArr: ["new", "hot", "recommend", "experienceGold", "livre"],
      gameGroupBtnHideList: [],
      // curGameItem: this.item
    };
  },
  watch: {
    target: {
      handler: function () {
        if (this.$refs.bannerHeight.getAttribute("lazy") === "loading") {
          this.$forceUpdate();
        }
      },
      // deep: true,
      // immediate: true,
    },
  },
  computed: {
    curGameItem() {
      return this.item;
    },
    IsMobile() {
      return this.$store.getters.getIsMobile;
    },
    getImgHeight() {
      if (this.IsMobile) return 155;
      const containerWidth =
        document.body.clientWidth > 1340
          ? 1280
          : document.body.clientWidth - 60;
      return containerWidth * 0.15;
    },
    lang() {
      return this.$store.getters.getLang;
    },
    packetConfig() {
      return this.$store.getters.getPacketConfig?.packetInfo?.baseInfo || {};
    },
    gameShow() {
      return this.packetConfig.gameNameShowPosition || 0; // 1顶部外面，2顶部里面，3底部外面，4底部里面',
    },
    levelShow() {
      return this.packetConfig.horizontalPosition || 2;
      // "HORIZONTAL_POSITION_DEFAULT" "HORIZONTAL_POSITION_LEFT"1靠左，"HORIZONTAL_POSITION_CENTER"2居中，"HORIZONTAL_POSITION_RIGHT"3靠右
    },
    jp_show() {
      return this.packetConfig.gameIconShowJp === "ROW_STATUS_ENABLE";
    },
    // 收藏
    gameCollectionList() {
      return this.$store.getters.getCollection;
    },
    // 未收藏
    gameUnCollectionList() {
      return this.$store.getters.getUnCollection;
    },
    getAppConfig() {
      return this.$store.getters.getPacketConfig?.appConfig || {};
    },
    // 是否展示游戏组logo水印
    showBrandLogo() {
      return (
        this.$store.getters.getPacketConfig?.packetInfo?.config
          ?.showBrandLogo === "STATUS_BOOL_TRUE"
      );
    },
    // 是否有体验彩金钱包
    hasExperienceWallet() {
      return this.getAppConfig?.wallets?.includes("EXPERIENCE_WALLET") || false;
    },
    userData() {
      return this.$store.getters.user;
    },
    // 是否充值过
    isRecharge() {
      return this.userData?.isRecharge;
    },
  },
  async created() {},
  mounted() {},
  methods: {
    handleImageLoad(event, src) {
      if (this.loadingtype) {
        this.lazyStatus = "loaded"; // 延迟更新状态
        // event.target.src = src;
      }

      //
    },
    handleImageError(event) {
      // console.log(event, "event");
      this.loadingtype = false;
      event.target.src = this.loadingsrc; // 设置为错误图片
      this.lazyStatus = "error"; // 设置 lazyStatus 为 'error'
    },
    isCollectionGame(gameGroupInfo) {
      if (this.gameCollectionList.includes(gameGroupInfo.gameGroupSid)) {
        return true;
      }
      if (this.gameUnCollectionList.includes(gameGroupInfo.gameGroupSid)) {
        return false;
      }
      return gameGroupInfo.isCollect === "STATUS_BOOL_TRUE";
    },
    handleBtnHide(data) {
      // console.log(data)
      this.gameGroupBtnHideList = data || [];
    },
    // 能否试玩
    isCanTestPlay(item) {
      return (
        item.canTestPlay === "STATUS_BOOL_TRUE" &&
        this.$store.getters.getPacketConfig?.packetInfo?.config?.canTestPlay ===
          "STATUS_BOOL_TRUE" &&
        !this.isRecharge
      );
    },
    // 能否创房
    isCanNewRoom(item) {
      return (
        item.canNewRoom === "STATUS_BOOL_TRUE" &&
        this.$store.getters.getPacketConfig?.packetInfo?.config?.canNewRoom ===
          "STATUS_BOOL_TRUE"
      );
    },
    // 游戏组图片
    getGameUrl(item) {
      const field = this.IsMobile ? "miniOrH5" : "appOrPcUrl";
      return this.$utils.returnImgUrl(item[field]);
    },
    judgeMode(opt) {
      if (!this.IsMobile) return;
      console.log("judgeMode", opt);
      if (
        opt.rowStatus === "GAME_STATUS_MAINTENANCE" ||
        opt.rowStatus === "GAME_STATUS_SOON_ONLINE" ||
        this.gameGroupBtnHideList.includes(String(opt.gameGroupSid))
      ) {
        return false;
      }
      // h5去掉直接进入游戏的逻辑
      // if (!this.isCanTestPlay(opt) && !this.isCanNewRoom(opt)) {
      //   this.$store.commit("setRecordGame", opt);
      //   this.$eventPost("click", {
      //     eid: opt.oid || opt.eid,
      //     gameGroupSid: opt.gameGroupSid,
      //     time: Date.now(),
      //   });
      //   payGameFun(opt);
      // } else {
      if (this.IsMobile) {
        if (!this.isCanTestPlay(opt) && !this.isCanNewRoom(opt)) {
          this.payGame(opt, 2);
        } else {
          // 游戏详情页面
          this.$isPopShow({
            show: true,
            views: "hgame",
            data: {
              ...opt,
            },
          });
        }
      }
      // }
    },
    pcOtherPayGame(item) {
      const { gameConfig, secondaryJump1, secondaryJump2 } = item;

      if (gameConfig === "GAME_CONFIG_MULTIPLE_GAMES") {
        goJoinEvent({
          multipleGame: {
            secondaryJump1,
            secondaryJump2,
          },
          type: "Jump_TYPE_MULTIPLE_GAME",
        });
        this.$Bus.$emit("changeSearchDrawer", false);
        return;
      }

      if (this.IsMobile) {
        this.judgeMode(item);
      } else {
        if (!this.isCanTestPlay(item) && !this.isCanNewRoom(item)) {
          this.payGame(item, 2);
        }
      }
    },
    // PC弹出真玩、试玩收藏
    pcPayGame(opt) {
      if (this.IsMobile) return;
      if (
        opt.rowStatus === "GAME_STATUS_MAINTENANCE" ||
        opt.rowStatus === "GAME_STATUS_SOON_ONLINE" ||
        this.gameGroupBtnHideList.includes(String(opt.gameGroupSid))
      ) {
        return false;
      }
      if (this.cur_gid === opt.gameGroupSid) {
        return false;
      }
      this.currGameId = opt.gameGroupSid;
      return;
    },
    pcLeaveGame() {
      this.currGameId = null;
      return;
    },
    payGame(opt, canTestPlay, isRoom = false) {
      if (
        opt.rowStatus === "GAME_STATUS_MAINTENANCE" ||
        opt.rowStatus === "GAME_STATUS_SOON_ONLINE" ||
        this.gameGroupBtnHideList.includes(String(opt.gameGroupSid))
      ) {
        return false;
      }
      this.$store.commit("setRecordGame", opt);
      const replace = false;
      payGameFun(opt, canTestPlay, replace, isRoom);
      this.$emit("play", {
        ...opt,
        canTestPlay,
        isRoom,
      });
    },
    getGameIcon(keys, haveFreeBet) {
      let key = "";
      if (haveFreeBet === "STATUS_BOOL_TRUE") {
        key = "livre";
      } else {
        key = keys || null;
      }
      if (key === "experienceGold" && !this.hasExperienceWallet) {
        return false;
      }
      if (key && this.keyImgArr.includes(key)) {
        return require(`@/assets/new/${key}.png`);
      }
      return false;
    },
  },
};
